export class FetchMISCount{
    static readonly type = '[FETCH_MIS_COUNT] GET'
}

export class FetchMISData{
    static readonly type = '[FETCH_MIS_DATA] GET'
    constructor( public misType: string ){}
}